module.exports = __webpack_public_path__ + "static/media/lov.6be121d6.mp3";